import { cn } from "@/lib/utils";
import { createPortal } from "react-dom";
import DeepFocusHeader from "./DeepFocusHeader";
import DeepFocusView, { DeepFocusViewProps } from "./DeepFocusView";

interface DeepFocusOverlayProps extends DeepFocusViewProps {
    isDeepFocusActive: boolean;
    onClose: () => void;
}

const DeepFocusOverlay = ({
    isDeepFocusActive,
    onClose,
    ...deepFocusViewProps
}: DeepFocusOverlayProps) =>
    createPortal(
        <div
            className={cn(
                "fixed z-fullscreen inset-0 bg-gradient-to-b from-surface-gradient-ligth-purple to-surface-gradient-dark-purple transition-opacity duration-500",
                isDeepFocusActive
                    ? "opacity-100"
                    : "pointer-events-none opacity-0",
            )}
        >
            <DeepFocusHeader onClose={onClose} />
            {isDeepFocusActive && <DeepFocusView {...deepFocusViewProps} />}
        </div>,
        document.body,
    );

export default DeepFocusOverlay;
